(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.tab-btn');
    if (!btn) return;
    var wrap = btn.closest('[data-landing-section]');
    if (!wrap) return;
    var paneId = btn.getAttribute('data-tab');
    if (!paneId) return;
    wrap.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
    wrap.querySelectorAll('.tab-pane').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    var pane = document.getElementById(paneId);
    if (pane) pane.classList.add('active');
  });
})();
